$(function () {
  $('.slider-for').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    asNavFor: '.slider-nav',
  });
  $('.slider-nav').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    prevArrow:
      "<img class='a-left control-c prev slick-prev lazyload' data-src='https://cdn.shopify.com/s/files/1/2021/9723/files/icons8-chevron-left-64.png?v=1633083470' alt='left arrow'>",
    nextArrow:
      "<img class='a-right control-c next slick-next lazyload' data-src='https://cdn.shopify.com/s/files/1/2021/9723/files/icons8-chevron-right-64.png?v=1633083470' alt='right arrow'>",
  });
  $('.slider-for').show();
  $('.slider-nav').show();
});
